import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { ProductExperience } from '../components/ProductExperience';
import { CompetitiveEdge } from '../components/CompetitiveEdge';
import { CaseStudy } from '../components/CaseStudy';
import { LeadershipSection } from '../components/LeadershipSection';
import { FinalCTA } from '../components/FinalCTA';
import { SiteFooter } from '../components/ui/SiteFooter';
export function FemEntityLanding() {
  return <main className="min-h-screen bg-ivory font-sans text-charcoal selection:bg-purple-200 selection:text-charcoal" data-id="element-613" data-mp="rv1lbwxt2psg">
      {/* Navigation placeholder - minimal for landing page */}
      <nav className="absolute top-0 left-0 right-0 z-50 px-6 py-6 flex justify-between items-center max-w-7xl mx-auto" data-id="element-614" data-mp="my1jxzbwib7o">
        <img src="https://cdn.magicpatterns.com/uploads/xpYure8muF9bisffxXgVg2/fementity.png" alt="Fem Entity" className="h-12 md:h-16 drop-shadow-lg" data-id="element-615" data-mp="37mfqq0c4m33g" />
        <div className="hidden md:flex space-x-8 text-sm font-medium text-charcoal/80" data-id="element-616" data-mp="3j134g4yu171o">
          <a href="/get-the-app" className="hover:text-purple-700 transition-colors" data-id="element-617" data-mp="3iyqrk67xlmvh">
            Download the App
          </a>
          <a href="/practitioners" className="hover:text-purple-700 transition-colors" data-id="element-618" data-mp="39z3qjlj46j2y">
            Practitioners
          </a>
        </div>
      </nav>

      <Hero data-id="element-619" data-mp="3038xrxl6f7mg" />
      <ProblemSection data-id="element-620" data-mp="303s7ws4l4rpx" />
      <CaseStudy data-id="element-621" data-mp="304bqmb227k50" />
      <SolutionSection data-id="element-622" data-mp="2masviz03ndml" />
      <ProductExperience data-id="element-623" data-mp="2mblrd4xisipy" />
      <CompetitiveEdge data-id="element-624" data-mp="2mcdo4j2usmht" />
      <LeadershipSection data-id="element-625" data-mp="2m8pvdm58g445" />
      <FinalCTA data-id="element-626" data-mp="2r9nkkiontyf5" />

      <SiteFooter currentPath="/" data-id="element-627" data-mp="2r944l7iklk3r" />
    </main>;
}